<template>
  <div class="setting__container">
    <div class="setting__content">
      <avatar-input :src="avatar" @onChange="handleAvatarUpdate" />
      <div class="setting__button-group">
        <vs-input
          class="w-full no-icon-border mb-1"
          type="text"
          label="Nome completo *"
          v-model="name"
          @blur="handleUpdateName"
          @keyup.enter="handleUpdateName"
          :danger="errors.length > 0"
          :danger-text="errors[0]"
        />
        <vs-button
          class="w-full"
          type="border"
          @click="() => (email_popupActive = true)"
        >
          Alterar E-mail
        </vs-button>
        <vs-button
          class="w-full"
          type="border"
          @click="() => (password_popupActive = true)"
        >
          Alterar Senha
        </vs-button>
        <vs-button
          class="w-full delete-account"
          @click="() => (deleteConfirm_popupActive = true)"
          :disabled="deleteBtn_Disabled"
        >
          Deletar conta
        </vs-button>
      </div>
      <div class="setting__button-group">
        <vs-button
          icon="chevron_left"
          class="w-full back-button"
          type="flat"
          @click="$router.back()"
        >
          Voltar
        </vs-button>
      </div>
    </div>

    <vs-popup title="Alterar e-mail" :active.sync="email_popupActive">
      <div class="popup__wrapper">
        <validation-observer
          ref="email"
          tag="form"
          @submit.prevent="handleEmailSubmit()"
        >
          <vs-row>
            <span v-if="email_error_msg" class="text-danger mx-auto mb-5">
              • {{ email_error_msg }}
            </span>
            <vs-col vs-w="12">
              <vs-input
                disabled
                class="w-full no-icon-border mb-5"
                name="current"
                type="email"
                label="E-mail atual"
                v-model="email"
              />
            </vs-col>
            <vs-col vs-w="12">
              <validation-provider
                name="email"
                vid="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full no-icon-border mb-5"
                  name="email"
                  type="email"
                  label="Novo e-mail"
                  :danger="errors.length > 0"
                  :danger-text="errors[0]"
                  v-model="novo_email"
                />
              </validation-provider>
            </vs-col>
            <vs-col vs-w="12">
              <validation-provider
                name="confirmar_email"
                rules="required|confirmed:email"
                v-slot="{ errors }"
              >
                <vs-input
                  class="w-full no-icon-border mb-5"
                  name="confirmar_email"
                  type="email"
                  label="Confirmar novo e-mail"
                  :danger="errors.length > 0"
                  :danger-text="errors[0]"
                  v-model="confirmar_email"
                />
              </validation-provider>
            </vs-col>

            <div class="popup__actions">
              <vs-button
                class="mx-1 back-button"
                @click="() => (email_popupActive = false)"
                color="dark"
                type="flat"
              >
                Cancelar
              </vs-button>
              <vs-button
                class="mt-5"
                type="filled"
                :color="color"
                @click="handleEmailSubmit"
              >
                Salvar
              </vs-button>
            </div>
          </vs-row>
        </validation-observer>
      </div>
    </vs-popup>

    <vs-popup title="Alterar senha" :active.sync="password_popupActive">
      <div class="popup__wrapper">
        <validation-observer
          ref="password"
          tag="form"
          @submit.prevent="handlePasswordSubmit()"
        >
          <vs-row>
            <span v-if="error_message" class="text-danger mx-auto mb-5">
              • {{ error_message }}
            </span>
            <vs-col vs-w="12">
              <validation-provider
                name="senha_atual"
                rules="required"
                v-slot="{ errors, touched }"
              >
                <vs-input
                  class="w-full no-icon-border mb-5"
                  name="senha_atual"
                  type="password"
                  label="Senha atual"
                  :danger="errors.length > 0 || touched"
                  :danger-text="errors[0]"
                  v-model="current_password"
                />
              </validation-provider>
            </vs-col>
            <vs-col vs-w="12">
              <validation-provider
                name="nova_senha"
                vid="nova_senha"
                rules="required|min:6"
                v-slot="{ errors, touched }"
              >
                <vs-input
                  class="w-full no-icon-border mb-5"
                  name="nova_senha"
                  type="password"
                  label="Nova senha"
                  :danger="errors.length > 0 || touched"
                  :danger-text="errors[0]"
                  v-model="password"
                />
              </validation-provider>
            </vs-col>
            <vs-col vs-w="12">
              <validation-provider
                name="confirmar_senha"
                rules="required|confirmed:nova_senha"
                v-slot="{ errors, touched }"
              >
                <vs-input
                  class="w-full no-icon-border mb-5"
                  name="confirmar_senha"
                  type="password"
                  label="Confirmar senha"
                  :danger="errors.length > 0 || touched"
                  :danger-text="errors[0]"
                  v-model="password_confirmation"
                />
              </validation-provider>
            </vs-col>
          </vs-row>
          <div class="popup__actions">
            <vs-button
              class="mx-1"
              @click="() => (password_popupActive = false)"
              color="dark"
              type="flat"
            >
              Cancelar
            </vs-button>
            <vs-button
              class="mt-5"
              type="filled"
              :color="color"
              @click="handlePasswordSubmit"
            >
              Salvar
            </vs-button>
          </div>
        </validation-observer>
      </div>
    </vs-popup>

    <vs-popup title="Tem certeza que deseja deletar conta?" :active.sync="deleteConfirm_popupActive">
      <div class="popup__wrapper">
          <vs-row>
            <vs-col>
              <p class="mb-5">
                Ao deletar a sua conta, todos os seus dados serão perdidos e suas candidaturas excluídas permanentemente.
              </p>
              <p class="mb-5">
                Caso deseje participar de um processo seletivo na nossa plataforma futuramente, você precisará criar uma nova conta e inserir seus dados novamente.
              </p>
              <p class="mb-5">
                Por favor, para confirmar esta ação, digite a senha da sua conta.
              </p>
            </vs-col>
          </vs-row>

          <validation-observer
          ref="delete"
          tag="form"
          @submit.prevent="handleDeleteSubmit"
        >
          <vs-row>

            <vs-col vs-w="12">
              <validation-provider
                name="senha"
                rules="required"
                v-slot="{ errors, touched }"
              >
                <vs-input
                  class="w-full no-icon-border mb-1"
                  name="senha"
                  type="password"
                  label="Senha"
                  placeholder="Insira aqui sua senha para deletar a conta"
                  :danger="errors.length > 0 || touched"
                  :danger-text="errors[0]"
                  v-model="delete_password"
                />
              </validation-provider>
              <div class="signin__forgot-password text-right">
                <router-link to="forgot-password">Esqueceu a sua senha?</router-link>
              </div>
            </vs-col>
            <vs-col vs-w="12">
              <div class="delete-confirmation-box">
                <validation-provider
                  name="confirmacao_delete"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-checkbox v-model="delete_confirmation" size="small" :color="color">
                    Estou desistindo das minhas candidaturas ativas e desejo deletar minha conta
                  </vs-checkbox>
                  <span v-if="errors.length > 0" class="text-danger">
                    • É necessário confirmar que deseja deletar a conta
                  </span>
                </validation-provider>
              </div>
            </vs-col>
            <span v-if="error_message" class="text-danger mx-auto mb-5">
              {{ error_message }}
            </span>
          </vs-row>

          <div class="popup__actions">
            <vs-button
              class="mx-1"
              @click="() => (deleteConfirm_popupActive = false)"
              color="dark"
              type="flat"
            >
              Cancelar
            </vs-button>
            <vs-button
              class="mt-5"
              type="filled"
              color="#DC143C"
              @click="handleDeleteSubmit"
            >
              Deletar Conta
            </vs-button>
          </div>
        </validation-observer>
      </div>
    </vs-popup>

    <vs-popup title="Conta excluída com sucesso" :active.sync="deleteSuccess_popupActive" @close="doLogout()">
      <div class="popup__wrapper">
          <vs-row>
            <vs-col>
              <div class="text-center">
                <img class="mb-5" src="@/assets/images/deleteSuccess.png" alt="ilustração representando uma pessoa jogando um documento em uma lata de lixo">
              </div>
              <p class="mb-5">A sua conta foi excluída com sucesso e todos os seus dados e candidaturas foram apagados.</p>
              <p class="mb-5">Obrigado por usar nosso serviço. Volte quando quiser. 🙂</p>
            </vs-col>
          </vs-row>

        <div class="popup__actions">
          <vs-button
            class="mx-1"
            :color="color"
            @click="doLogout"
          >
            Logout
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Desculpe, ocorreu um erro ao deletar sua conta!" :active.sync="deleteFail_popupActive">
      <div class="popup__wrapper">
          <vs-row>
            <vs-col>
              <p class="mb-5"> Por favor, tente novamente mais tarde ou entre em contato pelo e-mail <a href="mailto:contato@recrutei.com.br">contato@recrutei.com.br</a> para obter ajuda.</p>
            </vs-col>
          </vs-row>

        <div class="popup__actions">
          <vs-button
            class="mx-1"
            type="flat"
            color="dark"
          >
          <a href="mailto:contato@recrutei.com.br">Quero enviar um e-mail para o suporte</a>
          </vs-button>
          <vs-button
            class="mx-1"
            :color="color"
            @click="() => (deleteFail_popupActive = false)"
          >
            Fechar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import {mapState, mapActions} from 'vuex';
import AvatarInput from "@/components/AvatarInput";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AvatarInput,
  },
  data: () => ({
    termsAndConditions: false,
    email_popupActive: false,
    password_popupActive: false,
    deactivate_popupActive: false,
    deleteConfirm_popupActive: false,
    deleteSuccess_popupActive: false,
    deleteFail_popupActive: false,
    deleteBtn_Disabled: false,
    error_message: "",
    email_error_msg: "",
    name: "",
    email: "",
    novo_email: "",
    confirmar_email: "",
    current_password: "",
    password: "",
    password_confirmation: "",
    delete_password: "",
    delete_confirmation: false,
    file: [],
  }),
  methods: {
    handleUpdateName() {
      this.$vs.loading({ text: "Enviando..." });

      this.$store
        .dispatch("basicInfo/updateName", { name: this.name })
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    async handleEmailSubmit() {
      const isValid = await this.$refs.email.validate();
      if (!isValid) return;

      this.$vs.loading({ text: "Enviando..." });

      this.$store
        .dispatch("basicInfo/updateEmail", { email: this.novo_email })
        .then(() => {
          this.$refs.email.reset();

          this.email_popupActive = false;
          this.$vs.loading.close();

          this.novo_email = "";
          this.confirmar_email = "";
          this.email_error_msg = "";
          this.email = this.$store.state.basicInfo.basicInfo.email;

          this.$vs.notify({
            text: "Seu email foi atualizado com sucesso!",
            title: "Atualização!",
            icon: "icon-alert-circle",
            color: "success",
            iconPack: "feather",
            time: 3000,
            position: "top-right",
          });
        })
        .catch((error) => {
          const { status, data } = error.response;

          if (status === 422) this.email_error_msg = data.errors.email[0];

          this.$vs.loading.close();
        });
    },
    handleAvatarUpdate(file) {
      const { company_label } = this.$router.history.current.params;

      this.$vs.loading({ text: "Enviando..." });

      this.$store
        .dispatch("basicInfo/updateAvatar", {
          file,
          label: company_label,
        })
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    handleTermsAndConditions() {
      this.termsAndConditions = !this.termsAndConditions;
    },
    async handlePasswordSubmit() {
      const isValid = await this.$refs.password.validate();

      if (!isValid) return;

      this.$vs.loading({ text: "Atualizando..." });

      this.$http
        .post("api/v2/talents/password/redefine", {
          password: this.password,
          current_password: this.current_password,
          password_confirmation: this.password_confirmation,
        })
        .then(() => {
          this.$refs.password.reset();

          this.password_popupActive = false;
          this.$vs.loading.close();

          this.password = "";
          this.current_password = "";
          this.password_confirmation = "";
          this.error_message = "";

          this.$vs.notify({
            text: "Sua senha foi atualizada com sucesso!",
            title: "Atualização!",
            icon: "icon-alert-circle",
            color: "success",
            iconPack: "feather",
            time: 3000,
            position: "top-right",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();

          const { data, status } = error.response;

          if (status === 406) this.error_message = data.exception;
        });
    },
    async handleDeleteSubmit() {
      const isValid = await this.$refs.delete.validate();

      if (!isValid) return;

      if (!this.delete_confirmation) {
        this.error_message = "É necessário confirmar que deseja deletar a conta";
        return;
      }

      this.$vs.loading({ text: "Processando..." });

      this.$http
        .post("api/v2/talents/profile/user/destroy", {
          delete_password: this.delete_password,
        })
        .then(() => {
          this.deleteBtn_Disabled = true;
          this.$vs.loading.close();
          this.$refs.delete.reset();
          this.deleteConfirm_popupActive = false;
          this.delete_password = "";
          this.delete_confirmation = false;
          this.error_message = "";
          this.deleteSuccess_popupActive = true;
        })
        .catch((error) => {
          this.$vs.loading.close();
          const { data, status } = error.response;
          if (status === 422) {
            this.error_message = data.errors[0].errors;
          } else {
            this.deleteConfirm_popupActive = false;
            this.deleteFail_popupActive = true;
          }
        });
    },
    ...mapActions("basicInfo", ["clearBasicInfoState"]),
    ...mapActions("curriculum", ["clearCurriculumState"]),
    ...mapActions("address", ["clearAddressState"]),
    ...mapActions("experience", ["clearExperienceState"]),
    ...mapActions("language", ["clearLanguageState"]),
    ...mapActions("formation", ["clearFormationState"]),
    ...mapActions("skill", ["clearSkillState"]),
    doLogout() {
      if (this.isUserLoggedIn) {
        localStorage.clear();
        sessionStorage.clear();
        this.clearBasicInfoState();
        this.clearCurriculumState();
        this.clearAddressState();
        this.clearExperienceState();
        this.clearLanguageState();
        this.clearFormationState();
        this.clearSkillState();
        this.$store.dispatch("updateTab", 1);
      }
      const params = this.$router.history.current.params;
      this.$router.push({ name: "signin", params: { ...params } });
    },
  },
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    avatar() {
      return this.$store.state.basicInfo.basicInfo.photo_url;
    },
    ...mapState("auth", ["isUserLoggedIn"]),
  },
  created() {
    const { name, email} = this.$store.state.basicInfo.basicInfo;

    this.name = name;
    this.email = email;
  },
  beforeRouteLeave(to, from, next) {
    var popups = document.getElementsByClassName("con-vs-popup");
    for (var i = 0; i < popups.length; i++) {
      popups[i].style.display = "none";
    }
    next();
  },
};
</script>

<style lang="scss">
.setting__container {
  display: flex;
  flex-direction: column;
}

.setting__content {
  width: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 24px auto;

  .setting__button-group {
    margin: 20px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .vs-button {
      color: #4f4f4f;
      border-color: #A8A8A8;
      
      &.delete-account {
        color: #D20A32;
        background: #F0C8D0!important;
        border:0.5px solid #DC143C;
        &:hover {
          background: #DC143C!important;
          color: #fff;
          box-shadow: none !important;
        }
      }

      &.back-button {
        color: #4f4f4f;
        .vs-button-text.vs-button--text {
          text-decoration: underline;
        }

        &:hover {
          background: transparent!important;
        }

        &:active {
          background: transparent!important;
        }
      }
    }
  }
}
.vs-input {
  .vs-input--label {
    color: #333;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.75px;
  }
  .vs-con-input {
    margin-top: 8px;
    .vs-input--input {
      padding-top: 8px;
      border-radius: 8px;
      color: #4f4F4F;
      font-size: 16px;
      font-weight: 400;
      line-height: 18.75px;
    }
  }
}
.popup__actions {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
  button {
    flex-grow: 1;
  }
}

.delete-confirmation-box {
  width: 100%;
  padding: 16px;
  border: 0.5px solid #D4D4D4;
  border-radius: 8px;
  margin: 16px 0;
  font-size: 14px;
}
</style>
